import React, { FC } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import Tooltip from '../Tooltip/Tooltip';
import ListItem from './list-item/list-item';

type Props = {
    items: {
        value: any, isSelected: boolean, label: string, optionalColumns
        : any[]
    }[],
    onSelect: (index: number, item: any, label: string) => void,
    isStriped: boolean,
    isMultiSelect?: boolean,
    listItemClassName?: string
    stripedListItemClassName?: string,
    selectedListItemClassName?: string,
    cyName?: string
}

const  List: FC<Props> = ({ items = [], onSelect, isStriped = false, isMultiSelect = false, listItemClassName = 'p-1', stripedListItemClassName = 'p-2', selectedListItemClassName, cyName }) => {

    const { translate } = useLocale();

    const handleSelect = (i, item) => {
        if (!isMultiSelect) {
            items.forEach((item) => {
                if (item.isSelected) {
                    item.isSelected = false;
                }
            })
        }

        item.isSelected = item.isSelected ? false : true;
        onSelect(i, item.value, item.label);
    };

    return (
        <ul id='searchLookUpListItemsId'>
            {items[0]?.optionalColumns &&
                <div className={` ${items[0]?.optionalColumns && items[0]?.optionalColumns.length && `grid ${'grid-cols-' + (items[0]?.optionalColumns.length + 1)}  `} `} >
                    <div className=" ">
                        <ListItem
                            key={`dff`}
                            cyName={`listItem-name`}
                            onSelect={() => console.log()}
                            isSelected={false}
                            isStripe={false}
                            className={isStriped ? `border ${stripedListItemClassName}` : `border  ${listItemClassName} ${isMultiSelect ? 'pl-6' : ''}`}
                            checkSelect={isMultiSelect}
                            selectedListItemClassName={selectedListItemClassName}>
                            <strong>
                                {translate.byKey(TranslationKeys.name)}
                            </strong>
                        </ListItem>
                    </div>
                    {items[0]?.optionalColumns && items[0].optionalColumns.map(column =>
                        <div className="">
                            <strong>
                                <div className=" ">
                                    <ListItem
                                        cyName={`listItem-key`}
                                        key={`dff`}
                                        onSelect={() => console.log()}
                                        isSelected={false}
                                        isStripe={false}
                                        className={isStriped ? `border ${stripedListItemClassName}` : ` ${listItemClassName} ${isMultiSelect ? 'pl-6' : ''}`}
                                        checkSelect={isMultiSelect}
                                        selectedListItemClassName={selectedListItemClassName}>
                                        <strong>
                                            {translate.byKey(TranslationKeys[column.key])}
                                        </strong>
                                    </ListItem>
                                </div>
                            </strong>
                        </div>)}
                </div>}
            {items.map((item, i) => (<>
                <ListItem
                    cyName={`listItem-${i}`}	
                    optionalColumns={item.optionalColumns}
                    key={`li-${i}`}
                    onSelect={() => handleSelect(i, item)}
                    isSelected={item.isSelected}
                    isStripe={isStriped && i % 2 === 0}
                    className={isStriped ? `border ${stripedListItemClassName}` : `border-b border-solid ${listItemClassName} ${isMultiSelect ? 'pl-6' : ''}`}
                    checkSelect={isMultiSelect}
                    selectedListItemClassName={selectedListItemClassName}
                >
                    <div className={` ${item.optionalColumns && item.optionalColumns.length && `grid ${'grid-cols-' + (item.optionalColumns.length + 1)}  gap-3`} `}>
                        <Tooltip text={item.label} contentPositionX={'start'} show>
                            <p className={item.optionalColumns ? `multi-column` : `single-column`}>
                                {item.label}
                            </p>
                        </Tooltip>

                        {item.optionalColumns && item.optionalColumns.length > 0 && item.optionalColumns.map(column =>
                            <Tooltip show text={column.value}>
                                <div className={`multi-column`}>
                                    {column.value}
                                </div>
                            </Tooltip>
                        )}
                    </div>
                </ListItem>
            </>
            ))}
        </ul>
    );
}

export default List;
